import type {StudyDb} from '@cp/model';
import {getStudyCollectionPath} from '@cp/model';
import {collection, CollectionReference} from 'firebase/firestore';
import {firebaseFirestore} from '../../config/firebase';

export function getStudyCollection(moduleId: string): CollectionReference<StudyDb> {
  return collection(firebaseFirestore, getStudyCollectionPath(moduleId));
}
